<template lang="pug">
  .component-create-entity-button
    ModalReveal(ref="addCommonCost")
      slot(slot="trigger")
        i.fa.fa-plus-circle.fa-2x
      .body
        .row
          .column
            label Common cost
              SelectizeCommonCost(@optionSelected="selected")
          .columns
            label Reason
              input(type="text", v-model="body.reason")

      .row.columns(slot="footer")
        ActionButton(:action="save") Save
</template>
<script type="text/babel">
  import ModalReveal from '../../foundation/ModalReveal'
  import VatAmountToggler from '../../../backoffice/VatAmountToggler'
  import ActionButton from '../ActionButton'
  import SelectizeCommonCost from '../lists/selectize/SelectizeCommonCost'
  import KeplerBackofficeSdk from '../../../../lib/kepler/backoffice'
  import MaggieHelper from '../../../../maggieHelper'

  export default {
    name: 'AddCommonCostToWallet',
    components: {SelectizeCommonCost, ActionButton, VatAmountToggler, ModalReveal},
    data() {
      return {
        isDebit: false,
        body: {
          client_id: this.$route.params.id,
          wallet_id: this.wallet,
          common_cost_id: null,
        }
      }
    },
    created() {
      if (this.cost) {
        Object.assign(this.body, this.cost)
      }
    },
    methods: {
      save() {
        return KeplerBackofficeSdk.commonCosts.select(this.body.common_cost_id).addToWallet(this.body, () => {
          MaggieHelper.notification('Common cost', 'Added successfully')
          this.$refs.addCommonCost.close()
        })
      },
      selected(obj) {
        this.body.common_cost_id = obj.id
      }
    },
    props: ['wallet']
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .component-create-entity-button
    .modal-container
      height: auto
</style>



// WEBPACK FOOTER //
// AddCommonCostToWallet.vue?500b7f50